<template>
    <v-dialog v-model="show" max-width="390" persistent no-click-animation>
        <div class="ScenarioTestcaseCreator">
            <!--Dialog header-->
            <div class="dialog-header">
                <div>{{$f.tc('addTestcase')}}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Dialog content-->
            <div class="scrollbar-thin editor-content">
                <v-form v-model="formValid" ref="form" spellcheck="false">
                    <div class="centerY">
                        <div class="label-field">Test Set</div>
                        <v-combobox
                            v-model="model.group"
                            class="input-custom"
                            :items="testSetList"
                            :rules="formRules.required"
                            @input="$refs.TestcaseInput.validate()"
                            ref="GroupInput"
                        ></v-combobox>
                    </div>
                    <div class="centerY mt-8">
                        <div class="label-field">Testcase</div>
                        <v-text-field
                            outlined
                            v-model="model.name"
                            class="input-custom"
                            ref="TestcaseInput"
                            :rules="[formRules.ruleRequired, ruleDuplicateTestcase, ruleDuplicateSystemKeyword]"
                        ></v-text-field>
                    </div>
                </v-form>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-custom mr-8"
                     @click="submit">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import {v4 as uuidv4} from 'uuid'
import ScenarioService from "@/services/scenario.service";
import $const from "@/utils/const";

const defaultModel = {
    group: '',
    name: ''
}

export default {
    name: "ScenarioTestcaseCreator",
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            model: this.$utils.cloneObject(defaultModel),
            testSetList: [],
            testSetDetailList: []
        }
    },
    methods: {
        getDataAutoTest () {
            this.$appService.showLoading()
            ScenarioService.AutomationTestService.search(this.$route.params.scenarioId).then(
                result => {
                    let data = result.data
                    let items = []
                    data.forEach(item => {
                        if (!items.find(i => i.group === item.group)) {
                            items.push({
                                group: item.group,
                                testcases: data.filter(i => i.group === item.group)
                            })
                        }
                    })
                    // check the list does not contain the test set named "Unnamed"
                    if (!items.find(i => i.gr === "Unnamed")){
                        items.push({
                            group: "Unnamed",
                            testcases: []
                        })
                    }
                    this.testSetDetailList = items
                    this.testSetList = items.map(i => i.group)
                },
                this.$appService.handleRequestError()
            ).finally(this.$appService.hideLoading)
        },
        // functions for dialog
        open() {
            this.getDataAutoTest()
            if (this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.model.group = "Unnamed"
            this.model.name = `testcase-${uuidv4()}`
            this.show = true

            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        submitValidForm() {
            this.$refs.GroupInput.blur()
            this.close()
            this.promise.resolve(this.model)
        },
        ruleDuplicateTestcase (value) {
            let testSet = this.testSetDetailList.find(i => i.group === this.model.group)
            if (!testSet) return true
            if (testSet.testcases.length === 0) return true
            let testcases = testSet.testcases.map(i => i.name)
            let check = testcases.find(i => i !== value) ? true : false
            return check || this.$f.tc('formRules.fieldDuplicate')
        },
        ruleDuplicateSystemKeyword (value) {
            let check = value !== $const.RUN_ALL_TESTCASES ? true : false
            return check || this.$f.tc('formRules.fieldDuplicateSystemKeyword')
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioTestcaseCreator {
    background: #FFFFFF;
    font-size: 14px;
    border-radius: 5px;
    overflow: hidden;

    .editor-content {
        padding: 12px;
    }

    .label-field {
        width: 70px;
    }
}

.input-custom {
    position: relative;
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right:12px !important;
        top: 9px !important;
    }

    .v-select {
        .v-input__slot {
            padding: 6px 4px 6px 12px;
        }

        .v-text-field__details {
            right: 32px !important;
        }
    }
}
</style>
